import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsDockerComponent } from './simple-icons-docker.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsDockerComponent ],
    exports:      [ SimpleIconsDockerComponent ],
    bootstrap:    []
})
export class SimpleIconsDockerModule {}
